import { render, staticRenderFns } from "./addresscoordinatesfield.vue?vue&type=template&id=32e09116"
import script from "./addresscoordinatesfield.vue?vue&type=script&lang=js"
export * from "./addresscoordinatesfield.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports